import { render, staticRenderFns } from "./ProgramHeader.vue?vue&type=template&id=2c9039bf&scoped=true&"
import script from "./ProgramHeader.vue?vue&type=script&lang=ts&"
export * from "./ProgramHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramHeader.vue?vue&type=style&index=0&id=2c9039bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9039bf",
  null
  
)

export default component.exports